import moment from 'moment';

export default {
    /**
     *
     * Format date in the format YYYY-MM-DD HH:mm,
     * but if we are in the same day we put today HH:mm
     * If it is the day before, we put yesterday HH:mm
     *
     * @param  date    the date to format
     * @return void
     */
    formatDate (date) {
        let today = moment();
        let yesterday = moment().subtract(1, 'day');
        if (date.isSame(today, 'day')) {
            return this.$i18n.t('today') + date.format(' H:mm');
        } else if (moment(date).isSame(yesterday, 'day')) {
            return this.$i18n.t('yesterday') + date.format(' H:mm');
        } else {
            return date.format('YYYY-MM-DD H:mm');
        }
    },

    /**
     * Format the date in the format YYYY-MM-DD HH:mm to the right UTC time.
     *
     * @param  date    the date to format
     * @return string
     */
    toUtc (date) {
        const formated = moment(date).utc();
        return {
            date: formated.format('YYYY-MM-DD'),
            time: formated.format('HH:mm')
        };
    },

    /**
     * Format the date in the format YYYY-MM-DD HH:mm user timezone.
     *
     * @param  date    the date to format
     * @return string
     */
    fromUtc (date) {
        const formated = moment.utc(date).local();
        return {
            date: formated.format('YYYY-MM-DD'),
            time: formated.format('HH:mm')
        };
    },

    /**
     * Format phone number in the format 555-555-5555
     *
     * @param  phoneNumber the number to format
     * @return string
     */
    formatPhoneNumber (phoneNumber) {
        const cleaned = phoneNumber.replace(/\D/g, '');
        const match   = cleaned.match(/(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return match[1] + '-' + match[2] + '-' + match[3];
        }
        return null;
    }
};
